import { computed, defineComponent, reactive, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import UserLogin from "./cpns/userLogin.vue";
import LoginDialog from "./cpns/loginDialog.vue";
import UserSheet from "@/baseui/userSheet/userSheet.vue";
export default defineComponent({
  name: "NavAside",
  setup: function setup() {
    var _userData$value;

    var router = useRouter();
    var store = useStore();
    var route = useRoute();
    var userData = computed(function () {
      return store.state.Login.userData;
    }); //明天

    var userSheet = computed(function () {
      return store.state.PlayList.userSheet;
    }); //明天

    /* 用户歌单请求 */

    var userSheetRes = reactive({
      uid: (_userData$value = userData.value) === null || _userData$value === void 0 ? void 0 : _userData$value.userId,
      limit: 30,
      offset: 0
    });

    if (userData.value.userId) {
      store.dispatch("PlayList/getUserSheet", userSheetRes);
    }

    var logDialog = ref(LoginDialog);
    var isRouter = ref(route.path);
    /* 菜单类型格式 */

    var musicCate = reactive([{
      icon: "icon-netease-cloud-music-line",
      title: "发现音乐",
      router: "/main/home"
    }, {
      icon: "icon-video1",
      title: "视频",
      router: "/main/video"
    }]);
    /* 歌单列表类型 */

    var userSheetType = reactive([{
      type: "创建的歌单",
      data: "create"
    }, {
      type: "收藏的歌单",
      data: "collect"
    }]);
    /* 监听路由的变化 */

    watch(route, function (newValue) {
      isRouter.value = newValue.path;
    }, {
      immediate: true
    }); //选中菜单更改颜色

    var activeClick = function activeClick(itemRouter) {
      isRouter.value = itemRouter;
      /* 根据点击的路由路径，跳转/main下的子路由 */

      router.push(itemRouter);
    }; //点击用户登录


    var loginClick = function loginClick() {
      //显示对话框
      logDialog.value.isDialog = true;
    };

    return {
      userSheetType: userSheetType,
      userSheet: userSheet,
      userData: userData,
      logDialog: logDialog,
      musicCate: musicCate,
      isRouter: isRouter,
      activeClick: activeClick,
      loginClick: loginClick
    };
  },
  components: {
    UserLogin: UserLogin,
    LoginDialog: LoginDialog,
    UserSheet: UserSheet
  }
});